import parseInt from 'lodash/parseInt';

export default (el, offset = 0) => {
  const { documentElement, body } = document;
  const elOffset =
    parseInt(documentElement.scrollTop || body.scrollTop) +
    el.getBoundingClientRect().top;
  return elOffset + parseInt(offset);
};
